import { render, staticRenderFns } from "./KeyData.vue?vue&type=template&id=b8dc5cec&"
import script from "./KeyData.vue?vue&type=script&lang=js&"
export * from "./KeyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports